import createContentUrl from '@/utils/createContentUrl'
import { type WhatsNewPayload } from '@/components/ContentManager/WhatsNewModal/components/WhatsNewModalNewsItem/types'

export const NEW_MESSAGES_MAX_COUNT = 99
export const WHATS_NEW_ENDPOINT = 'https://app.storyblok.com/v1/cdn/stories/'
export const getWhatsNewPayload = (page = 1): WhatsNewPayload => ({
  starts_with: 'general/whats-new/',
  token: createContentUrl().token,
  page,
  cv: createContentUrl().cv,
  version: createContentUrl().version,
})
